import { render, staticRenderFns } from "./OrderDetailModal.vue?vue&type=template&id=d5dbe96e&scoped=true"
import script from "./OrderDetailModal.vue?vue&type=script&lang=js"
export * from "./OrderDetailModal.vue?vue&type=script&lang=js"
import style0 from "./OrderDetailModal.vue?vue&type=style&index=0&id=d5dbe96e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5dbe96e",
  null
  
)

export default component.exports